import React, {useState, useEffect} from 'react'
import { Auth } from 'aws-amplify';
import { Translation } from 'react-i18next';
import {BllinkLogger} from '../../common/utils/bllink_loggers';
import Google from '../../images/google.svg';
import Facebook from '../../images/facebook.svg';
import loginLogic from './loginLogic';
import CacheData from "../../common/utils/cacheData";
import { constants } from "../../common/constants/constants";
import ReactGA from "react-ga4";
import {GAEvent} from "../../common/google_analytics/google_analytics";
import {useDispatch} from "react-redux";
import {onLogOut} from "../../store/common/persistentSlice";

function LoginTitle(){

    return (
        <Translation>{(t, {_}) =>
            <div className="container">
                <div className="row">
                    <div className="login-from col-md-12">
                        <h2 className="text-center">{t('login.login_building_title')}</h2>
                        <p>{t('login.login_building_sub_title')}</p>
                        {/*<p className="d-sm-block d-md-none red">{t('login.only_maintenance_on_mobile')}</p>*/}
                    </div>
                </div>
            </div>
        }</Translation>
    )
}


function LoginOptions(){
    return (
        <Translation>{(t, {_}) =>
            <div className="row">
                <div className="login_from">
                    <div className="login_form_11">
                        <div className="form-group">
                            <label className='label' htmlFor="Email">{t('signup.username')} * </label>
                            <input type="email" className="form-control" name="email"
                                   id="login-email" autoComplete="off"/>
                        </div>
                        <div className="form-group">
                            <label className='label' htmlFor="login-password">{t('signup.password')} * </label>
                            <input type="password" className="form-control" name="password"
                                   id="login-password" autoComplete="off"
                            />
                        </div>
                        <a href="/" id="forget-pwd" className='forgot-password'>{t('login.forgot_password')}</a>
                        <div className="row form-group col-12 col-md-11" hidden={true}>
                            <label id="login-error" className="error"/>
                        </div>
                    </div>

                    <div className="login_form_12">
                        <div className="form-group">
                            <label htmlFor="Email">{t('login.login_with')}: </label>
                            <a href="#" social-name="Google" className="link_load js-social-login">
                                <img social-name="Google" alt='google connect' src={Google}/>{t('login.google')}
                            </a>
                            <a href="#" social-name="Facebook" className="link_load js-social-login">
                                <img social-name="Facebook" alt='facebook connect' src={Facebook}/>{t('login.facebook')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        }</Translation>
    )
}

function LoginActions(){
    return (
        <Translation>{(t, {_}) =>
            <div className="login_last_sec">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group login_right">
                            <input type="submit" name="login-account" id="login-account"
                                   value={t('login.login_to_account')}/>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        {/*<div className="form-group login_left">*/}
                        {/*    <input type="submit" name="opan-account" id="opan-account"*/}
                        {/*           value={t('login.open_account')}/>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        }</Translation>
    )
}


export default function Login() {

    const dispatch = useDispatch();

    const [state] = useState({});

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(async () => {
        BllinkLogger.info(`Login initiated state `, state);
        // bind google and facebook click
        loginLogic.bindSocialClick()
        loginLogic.bindLoginButtonClicked();
        loginLogic.bindForgotPassword();
        CacheData.delete('currentBuilding', {typeOfCache: sessionStorage});
        CacheData.delete('currentBuilding', {typeOfCache: localStorage});
        // related to task https://bllink.atlassian.net/browse/SSB-2116
        await dispatch(onLogOut());

        Auth.currentAuthenticatedUser()
            .then(user => {
                BllinkLogger.info('user is', user);
                ReactGA.set({
                    userId: user.attributes?.email
                })
                GAEvent(constants.GoogleAnalytics.Events.login, 'loginSuccess', 1, 'loginSuccess');
                // if user is logged in, redirect to all buildings
                //https://app.asana.com/0/1196545425570329/1199505058552496
                CacheData.delete('lastPage');
                window.location.href = `/${constants.pages.allBuildingsUrl}`
                // to avoid endless loop (happened for one of clients), we will not redirect and force the user
                // to reconnect
            })
            .catch((e) =>
                BllinkLogger.info('Not signed in ', e)
            );

    });

    return (
        <div>
            <LoginTitle/>

            <section>
                <div className="container">
                    <div className="col-md-12">
                        <div className="login_detail">
                            <form>
                                <LoginOptions/>
                                <LoginActions/>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

